import { CHECK_LOGIN_URL, checkAuth } from './apiService.js'

export async function checkLogin() {
  try {
    const response = await checkAuth()
    if (response.redirected) {
      window.location.href = response.url
    }
    return true;
  }
  catch (e) {
    console.warn(e)
    window.location.href = CHECK_LOGIN_URL
  }
  return false;
}
